import type Trail from '@alltrails/types/Trail';
import type { PageUITrailResultSection } from './pageUI';

/**
 * The Trail that trail cards need, built from a `trail-result` section. Fills only what the cards read.
 */
const trailFromPageUISection = (section: PageUITrailResultSection): Trail => {
  // `difficultyRating` is a string, so a missing one would otherwise come through as NaN
  const difficulty = section.difficultyRating ? Number(section.difficultyRating) : undefined;

  return {
    id: section.trailId,
    name: section.name,
    slug: section.slug,
    area: { name: section.locationLabel },
    avgRating: section.avgRating,
    defaultActivityStats: { difficulty, rating: section.avgRating },
    trailCounts: { reviewCount: section.numReviews ?? 0 },
    trailGeoStats: {
      durationMinutes: section.durationMinutes?.toString(),
      length: section.length
    }
  };
};

export default trailFromPageUISection;
